import React, { useContext } from 'react';
import './style.scss';
import { SearchContext } from '../context/SearchContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const ResultsItems = () => {
    const { resultsPageDataRetrievedItems } = useContext(SearchContext);

    // Filter out items where hidePage is true
    const filteredItems = resultsPageDataRetrievedItems?.filter(item => {
        const hideFromSearch = item?.item?.hidePage?.value;
        return hideFromSearch !== "1" && hideFromSearch !== "true"; // Check both formats
    });

    return (
        <div className="result-items">
            {filteredItems?.map((item, index) => {
                const categoryName = { value: item?.category };
                const categoryTitle =
                    item?.item?.title?.value !== '' ? item?.item?.title : { value: item?.item?.name };
                const categorySummary = item?.item?.summary;

                const shouldRenderCategoryName = !!categoryName?.value;
                const shouldRenderCategoryTitle = !!categoryTitle?.value;
                const shouldRenderCategorySummary = !!categorySummary?.value;
                const resultLink = item?.item?.url;
                const shouldRenderResultLink = !!resultLink;

                return (
                    <div className="result-item" key={index}>
                        <div className="auto">
                            {shouldRenderCategoryName && (
                                <div className="result-category">
                                    <Text field={categoryName} />
                                </div>
                            )}
                            {shouldRenderCategoryTitle && (
                                <div className="result-title">
                                    <Text field={categoryTitle} />
                                </div>
                            )}

                            {shouldRenderCategorySummary && (
                                <div className="result-description">
                                    <Text field={categorySummary} />
                                </div>
                            )}
                        </div>
                        {shouldRenderResultLink && (
                            <a className="item-link" href={resultLink} target="_blank" rel="noreferrer noopener" />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ResultsItems;